import EditorPage from './pages/EditorPage.jsx';

export default function App() {
  return <EditorPage />;
}
